import { onLocationDetailsLoaded } from 'owa-location-card';
import { orchestrator } from 'satcheljs';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { toJS } from 'mobx';
import { updateLocations } from 'owa-calendar-compose-form-actions';
import type PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';

orchestrator(onLocationDetailsLoaded, actionMessage => {
    let event = getComposeStore().event;
    if (event?.Locations) {
        const { locationId, latitude, longitude } = actionMessage;

        let enhancedLocations: EnhancedLocation[] = [];
        event.Locations.forEach(x => {
            if (x.Id == locationId) {
                let location: EnhancedLocation = toJS(x);
                if (location.PostalAddress) {
                    if (!location.PostalAddress.Latitude || !location.PostalAddress.Longitude) {
                        location.PostalAddress.Latitude = latitude;
                        location.PostalAddress.Longitude = longitude;
                    }
                } else {
                    const postalAddress: PersonaPostalAddress = {
                        Latitude: latitude,
                        Longitude: longitude,
                    };

                    location.PostalAddress = postalAddress;
                }

                enhancedLocations.push(location);
            } else {
                enhancedLocations.push(x);
            }
        });

        updateLocations(enhancedLocations);
    }
});
